export default {"src":"https://fishbrain.com/_next/static/media/waveBlueBottom.27102d3f.svg","height":67,"width":1440,"blurWidth":0,"blurHeight":0};